import { GET_ACCOUNT_OKTA_DATA, LOGIN_USER, RESET_ACTION_HASH } from '../../../../constants/system/actions';

const getAccountOktaData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_ACCOUNT_OKTA_DATA, payload, resolve, reject,
});

const loginUser: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: LOGIN_USER, payload, resolve, reject,
});

const resetActionHash: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: RESET_ACTION_HASH, payload, resolve, reject,
});

export {
  getAccountOktaData,
  loginUser,
  resetActionHash,
};
